import React from 'react'
import Svg, { Circle, Rect, Text as SvgText } from 'react-native-svg'
import type { BadgePalette } from './palettes'

export interface BadgeArtProps {
  /** Palette for the badge's currently earned tier (or its silhouette). */
  palette: BadgePalette
  size?: number
  /** Optional next-tier palette used by chip artwork with individually colorable segments. */
  nextPalette?: BadgePalette
  /** 0–1 progress toward the next tier; `null` when there is no next tier. */
  progressToNextTier?: number | null
}

interface BadgePlaceholderProps extends BadgeArtProps {
  /** Short label (badge initials) so placeholder badges are tellable apart in the grid. */
  label?: string
}

/**
 * Temporary badge art until designer SVGs land. Deliberately simple — a
 * rounded square built from all four palette slots — so it exercises the
 * full sentinel-palette system (tier colors, silhouette).
 */
export const BadgePlaceholder: React.FC<BadgePlaceholderProps> = ({ palette, size = 96, label }) => (
  <Svg width={size} height={size} viewBox="0 0 480 480">
    <Rect x={40} y={40} width={400} height={400} rx={64} fill={palette.primary} />
    <Rect x={72} y={72} width={336} height={336} rx={48} fill={palette.shade} />
    <Circle cx={240} cy={240} r={140} fill={palette.accent} />
    <Rect x={140} y={356} width={200} height={48} rx={24} fill={palette.detail} />
    {label ? (
      <SvgText x={240} y={268} fontSize={96} fontWeight="bold" fill={palette.detail} textAnchor="middle">
        {label}
      </SvgText>
    ) : null}
  </Svg>
)
